// src/app/store.ts
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import binanceReducer from '../features/binance/binanceSlice';
import botsReducer from '../features/bots/botsSlice';
import globalStatReducer from '../features//globalStat/globalStatsSlice';
import paymentsReducer from '../features/payments/paymentsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    binance: binanceReducer,
    bots: botsReducer,
    globalStat: globalStatReducer,
    payments: paymentsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
